Jelly.Actions.Trim = function(Parameters) {
	$Trim_Element = $("#" + Parameters.Namespace + "_Value");
	$Trim_Element.val($Trim_Element.val().trim());
};